/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2022-06-08 09:38:05
 * @LastEditors: sjq
 * @LastEditTime: 2022-06-08 09:48:13
 */
export const throttle = {
  inserted: (el, binding) => {
    let delay = binding.args || 1000
    let time = null
    // el.addEventListener('input', () => {
    //   if (!time) {
    //     time = setTimeout(() => {
    //       binding.value()
    //       time = null
    //     }, delay)
    //   }
    // })
    el.addEventListener('click', () => {
      // 禁用这个指令的DOM结构点击事件
      el.style.pointerEvents = 'none'
      if (!time) {
        time = setTimeout(() => {
          time = null
          el.style.pointerEvents = 'auto'
        }, delay)
      }
    })
  }
}
